import { render, staticRenderFns } from "./EmployeeRegistrationStatus.vue?vue&type=template&id=ee8a4a60&scoped=true"
import script from "./EmployeeRegistrationStatus.vue?vue&type=script&lang=js"
export * from "./EmployeeRegistrationStatus.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRegistrationStatus.vue?vue&type=style&index=0&id=ee8a4a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a4a60",
  null
  
)

export default component.exports